import Layout from "../template/Layout";
import {Route, Routes} from "react-router-dom";
import {NotFount} from "../../layouts/not-fount";
import Search from "../../layouts/search";
import Dashboard from "../../layouts/dashboard";
import Trays from "../../layouts/trays";
import ConfigScore from "../../layouts/config-score";
import Account from "../../layouts/account";
import Result from "../../layouts/trays/result";
import DashboardRuc from "../../layouts/dashboard-ruc";

function Body() {

    return (
        <Layout>
            <Routes>
                <Route path="/"
                       element={<Search/>}
                />
                <Route path="/search"
                       element={<Search/>}
                />
                <Route path="/dashboard/:personIdentification"
                       element={<Dashboard/>}
                />
                <Route path="/dashboard-ruc/:ruc"
                       element={<DashboardRuc/>}
                />
                <Route path="/trays"
                       element={<Trays/>}
                />
                <Route path="/config-score"
                       element={<ConfigScore/>}
                />
                <Route path="/account"
                       element={<Account/>}
                />
                <Route path="/result-analysis/:idResult"
                       element={<Result/>}
                />
                <Route path="/*"
                       element={<NotFount code={'404'}/>}
                />
            </Routes>
        </Layout>
    );
}

export default Body
